import { render, staticRenderFns } from "./adressesearch.vue?vue&type=template&id=97f45e6a&scoped=true"
import script from "./adressesearch.vue?vue&type=script&lang=js"
export * from "./adressesearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f45e6a",
  null
  
)

/* custom blocks */
import block0 from "./adressesearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports